<template>
  <search-layout>
    <template v-slot:contents>
      <field-input title="기간" cols="2">
        <date-input
          :start-date="startDate"
          :end-date="endDate"
          @updateDate="updateDate"
        />
      </field-input>
    </template>
    <template v-slot:button>
      <search-btn @click="search" />
    </template>
  </search-layout>
</template>
<script>
import SearchLayout from "@/common/layout/SearchLayout.vue";
import SearchBtn from "@/common/components/SearchBtn.vue";
import FieldInput from "@/common/components/input/FieldInput.vue";
import DateInput from "@/common/components/input/DateInput.vue";
import DateMixin from "@/mixin/DateMixin";

export default {
  name: "LoanPerformanceTotalSearchBar",
  components: {DateInput, FieldInput, SearchBtn, SearchLayout},
  mixins: [DateMixin],
  beforeMount() {
    const {fromDate, toDate} = this.getNowMonthAllDate();
    this.startDate = fromDate;
    this.endDate = toDate;
    this.$emit("defaultDate", {fromDate, toDate});
  },
  data() {
    return {
      startDate: "",
      endDate: "",
    }
  },
  methods: {
    search() {
      const params = {
        stDt: this.startDate.replaceAll("-", ""),
        edDt: this.endDate.replaceAll("-", "")
      };
      this.$emit("search", params);
    },
    updateDate(value) {
      this.startDate = value[0];
      this.endDate = value[1];
    }
  }
}
</script>